import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import type { ChatStrings } from './locales';

interface ChatFooterProps {
  branding: boolean;
  privacyUrl?: string;
  strings: ChatStrings;
}

export function ChatFooter({ branding, privacyUrl, strings }: ChatFooterProps) {
  const [dismissed, setDismissed] = useState(false);

  return (
    <div className="flex shrink-0 items-center justify-center gap-2 py-1.5">
      {/* Privacy badge — click to dismiss */}
      {!dismissed && privacyUrl && (
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="inline-flex items-center gap-1 rounded-full bg-muted/60 px-2.5 py-1 text-[10px] text-muted-foreground transition-colors hover:bg-muted dark:bg-white/[0.06] dark:text-white/40 dark:hover:bg-white/[0.1]"
        >
          <ShieldCheck className="size-3" />
          <a
            href={privacyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
            onClick={(e) => e.stopPropagation()}
          >
            {strings.privacyLink}
          </a>
        </button>
      )}

      {/* Powered by */}
      {branding && (
        <span className="text-[10px] text-muted-foreground/60 dark:text-white/20">
          {strings.poweredBy}{' '}
          <a
            href="https://chanl.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium underline-offset-2 hover:underline"
          >
            Chanl
          </a>
        </span>
      )}
    </div>
  );
}
